import { memo } from 'react';
import { cn } from '@divlab/divanui';

import Img from '@UI/Img';
import styles from './ConstructorImage.module.css';

import type { FC, HTMLAttributes } from 'react';

export interface ConstructorImageProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  images: string[];
}

const ConstructorImage: FC<ConstructorImageProps> = (props) => {
  const { className, images, ...restProps } = props;

  return (
    <div {...restProps} className={cn(styles.wrapper, className)}>
      {images.map((image) => (
        <Img key={image} src={image} className={styles.image} cnImage={styles.cnImage} />
      ))}
    </div>
  );
};

export default memo(ConstructorImage);
